import {
  publicRuntimeConfig as publicRuntimeConfigCustom,
  privateRuntimeConfig as privateRuntimeConfigCustom,
} from '../../_config';

/**
 * Runtime configuration
 * See https://nuxtjs.org/guide/runtime-config/
 */

function isTrueVal(envKey: string) {
  return ['true', '1'].includes(process.env[envKey] || '');
}

function stringVal(envKey: string) {
  return process.env[envKey] || '';
}

export const publicRuntimeConfig = () => ({
  appName: stringVal('APP_NAME'),
  appUrl: stringVal('NUXT_APP_URL'),
  originDomain: stringVal('ORIGIN_DOMAIN'),
  appStaticCdn: stringVal('APP_STATIC_CDN'),
  nodeEnv: stringVal('NODE_ENV'),
  withDebugBuild: isTrueVal('WITH_DEBUG_BUILD'),
  forceMigrationDate: stringVal('FORCE_MIGRATION_DATE'),
  brand: {
    language: stringVal('BRAND_DEFAULT_LANGUAGE') || 'pt-br',
    country: stringVal('BRAND_DEFAULT_COUNTRY') || 'BRA',
    currency: stringVal('BRAND_DEFAULT_CURRENCY') || 'BRL',
    timezone: stringVal('BRAND_DEFAULT_TIMEZONE') || 'America/Sao_Paulo',
  },
  BUILD_UNIQUE_ID: stringVal('BUILD_UNIQUE_ID'),
  gtmOverride: stringVal('GTM_OVERRIDE'),
  cactusgaming: 'multi-theme',
  hideExternalLinks: isTrueVal('HIDE_EXTERNAL_LINKS'),
  showGameListTitles: isTrueVal('SHOW_GAME_LIST_TITLES'),
  captcha: {
    turnstileSiteKey: stringVal('TURNSTILE_SITE_KEY'),
    turnstileAlwaysShow: isTrueVal('TURNSTILE_ALWAYS_SHOW'),
    recaptchaSiteKey: stringVal('RECAPTCHA_SITE_KEY'),
  },
  betBy: {
    brandId: stringVal('BETBY_BRAND_ID'),
    libraryUrl: stringVal('BT_LIBRARY_URL'),
    theme: stringVal('BETBY_THEME'),
    slsk: 'a240-0447a96155f2',
  },
  altenar: {
    integration: stringVal('ALTENAR_INTEGRATION'),
    libraryUrl: stringVal('ALTENAR_LIBRARY_URL'),
  },
  layout: {
    openDepositModalInterval: stringVal('DEPOSIT_MODAL_OPEN_INTERVAL_MS'),
    openDepositModalMinBalance: stringVal(
      'MINIMUM_WALLET_BALANCE_FOR_MODAL_OPEN',
    ),
  },
  tracker: {
    kwaiPixel: stringVal('KWAI_PIXEL'),
    taboolaId: stringVal('TABOOLA_ID'),
  },
  smartico: {
    libraryUrl: stringVal('SMARTICO_LIBRARY_URL'),
    brandId: stringVal('SMARTICO_BRAND_ID'),
    labelId: stringVal('SMARTICO_LABEL_ID'),
    saltKey: stringVal('SMARTICO_SALT_KEY'),
    visitorLabelId: stringVal('SMARTICO_VISITOR_LABEL_ID'),
    visitorBrandId: stringVal('SMARTICO_VISITOR_BRAND_ID'),
    allowLocalhost: isTrueVal('SMARTICO_ALLOW_LOCALHOST'),
    activeDebugs: isTrueVal('SMARTICO_ENABLE_DEBUGS'),
    activeNotifications: isTrueVal('SMARTICO_ACTIVE_NOTIFICATIONS'),
    requestPushNotification: isTrueVal('SMARTICO_REQUEST_PUSH'),
    isGamificationActive: isTrueVal('SMARTICO_ACTIVE_GAMIFICATION'),
    gamificationSpecificUsers: stringVal('SMARTICO_GAMIFICATION_ONLY_USERS'),
    gamificationMasterTesters: stringVal(
      'SMARTICO_GAMIFICATION_MASTER_TESTERS',
    ),
    exclusiveTournaments: stringVal('SMARTICO_EXCLUSIVE_TOURNAMENTS'),
    gamificationSpecificCountries: stringVal(
      'SMARTICO_GAMIFICATION_ONLY_COUNTRIES',
    ),
    gamificationName: stringVal('SMARTICO_GAMIFICATION_NAME') || 'ClubVip',
    gamificationCoinName:
      stringVal('SMARTICO_GAMIFICATION_COINS_NAME') || 'Coins',
    isGamificationNativeActive: isTrueVal(
      'SMARTICO_ACTIVE_NATIVE_GAMIFICATION',
    ),
    gamificationModules: {
      missions: isTrueVal('SMARTICO_GAMIFICATION_MISSIONS'),
      tournaments: isTrueVal('SMARTICO_GAMIFICATION_TOURNAMENTS'),
      store: isTrueVal('SMARTICO_GAMIFICATION_STORE'),
      minigames: isTrueVal('SMARTICO_GAMIFICATION_MINIGAMES'),
      levels: isTrueVal('SMARTICO_GAMIFICATION_LEVELS'),
      profile: isTrueVal('SMARTICO_GAMIFICATION_PROFILE'),
    },
    gamificationNativeModules: {
      missions: isTrueVal('SMARTICO_NATIVE_GAMIFICATION_MISSIONS'),
      tournaments: isTrueVal('SMARTICO_NATIVE_GAMIFICATION_TOURNAMENTS'),
    },
  },
  homologation: {
    blockedProviders: stringVal('HOMOLOGATION_BLOCKED_PROVIDERS'),
    allowedUsers: stringVal('HOMOLOGATION_ALLOWED_USERS'),
  },
  colors: {
    primary: stringVal('THEME_COLORS_DEFAULT_BG_PRIMARY'),
    secondary: stringVal('THEME_COLORS_HEADER_BG'),
    texts: stringVal('THEME_COLORS_DEFAULT_TEXTS'),
    bubble: stringVal('THEME_COLORS_DEFAULT_PRIMARY'),
    bgButton: stringVal('THEME_COLORS_DEFAULT_BUTTON_BG'),
    textButton: stringVal('THEME_COLORS_DEFAULT_BUTTON_TEXT'),
  },
  payments: {
    testUsers: stringVal('PAYMENTS_TEST_MODE_USERS'),
    // todo: remove after deploying to all brands
    getFromApi: isTrueVal('PAYMENTS_GET_FROM_API'),
    crypto: {
      activeDeposit: isTrueVal('PAYMENTS_CRYPTO_ACTIVE_DEPOSIT'),
      activeWithdraw: isTrueVal('PAYMENTS_CRYPTO_ACTIVE_WITHDRAW'),
      allowedCryptos: stringVal('PAYMENTS_CRYPTO_ALLOWED_CRYPTOS'),
    },
  },
  featureFlags: {
    betByTestMode: isTrueVal('BETBY_TEST_MODE'),
    betByActive: isTrueVal('BETBY_ACTIVE'),
    betByWidgetEnabled: isTrueVal('BETBY_WIDGET_ENABLED'),
    altenarTestMode: isTrueVal('ALTENAR_TEST_MODE'),
    altenarActive: isTrueVal('ALTENAR_ACTIVE'),
    maintenanceMode: isTrueVal('MAINTENANCE_MODE'),
    disableBrandGtm: isTrueVal('DISABLE_BRAND_GTM'),
    homeAsSportbook: isTrueVal('FEATURE_FLAG_HOME_AS_SPORTBOOK'),
    cactusSportsbook: {
      isEnabled: isTrueVal('FEATURE_FLAG_CACTUS_SPORTSBOOK'),
      testUsers: stringVal('FEATURE_FLAG_CACTUS_SPORTSBOOK_TEST_USERS'),
      testPage: isTrueVal('FEATURE_FLAG_CACTUS_SPORTSBOOK_TEST_PAGE'),
    },
    withdrawalReceipt: {
      isEnabled: isTrueVal('FEATURE_FLAG_WITHDRAWAL_RECEIPT_ACTIVE'),
      testUsers: stringVal('FEATURE_FLAG_WITHDRAWAL_RECEIPT_TEST_USERS'),
    },
    pokerSection: {
      isEnabled: isTrueVal('FEATURE_FLAG_POKER_ACTIVE'),
      testUsers: stringVal('FEATURE_FLAG_POKER_TEST_USERS'),
    },
    irpf: {
      isEnabled: isTrueVal('FEATURE_FLAG_IRPF_ACTIVE'),
      testUsers: stringVal('FEATURE_FLAG_IRPF_TEST_USERS'),
    },
    footerV2Active: isTrueVal('FEATURE_FLAG_FOOTER_V2_ACTIVE'),
  },
  ...publicRuntimeConfigCustom,
});

export const privateRuntimeConfig = () => ({
  isDeveloperMode:
    stringVal('NODE_ENV') !== 'production' &&
    stringVal('BUILD_STAGE') !== 'yes',
  isStageMode: isTrueVal('IS_STAGE'),
  buildKeepConsole: isTrueVal('BUILD_KEEP_CONSOLE'),
  appConfig: {
    name: stringVal('APP_NAME'),
    url: stringVal('NUXT_APP_URL'),
    port: stringVal('NUXT_APP_PORT'),
    protocol: stringVal('APP_PROTOCOL') || 'https://',
    defaultLang: stringVal('BRAND_DEFAULT_LANGUAGE') || 'pt-br',
  },
  apiConfig: {
    url: stringVal('NUXT_API_URL'),
    baseUrl: stringVal('NUXT_API_BASE_URL'),
  },
  ...privateRuntimeConfigCustom,
});

export type IPublicRuntimeConfig = ReturnType<typeof publicRuntimeConfig>;

export type IPrivateRuntimeConfig = ReturnType<typeof privateRuntimeConfig>;
